import { ErrorResponseErrorItemCodeCompany } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeCompany, string> = {
  'company:not_found': 'Företaget kunde inte hittas.',
  'company:user_unauthorized': 'Du saknar administratörsrättigheter för företaget.',
  'company:missing_design_tool_seat': 'Du saknar rättigheter för Design.',
  'company:skymap_connect_license_agreement_not_found':
    'Företaget saknar licens för SkyMap Connect.',
  'company:user_already_connected_to_design_tool_seat':
    'Användaren är redan tilldelad en Design licens.',
};
